import {NOTICE_FORM_CONFIG} from '../notice-form';
import {VisaFormConfig} from '../forms';

// Product layer (pass): extends base. Projects with custom forms spread NOTICE_FORM_CONFIG directly.
export const PASS_NOTICE_FORM: VisaFormConfig = {
  ...NOTICE_FORM_CONFIG
};
